import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isTelegram, showBackButton } from 'lib/telegram';

/** Mini App only. Hidden on shell roots — the dock is the way out there; elsewhere it pops one history entry. */

/** Screens that are a shell root: the dock is the way out, not a back chevron. */
const ROOT_PATHS = new Set([
  '/app',
  '/app/analytics',
  '/app/tests',
  '/app/documents',
  '/app/more',
  '/portal',
  '/portal/results',
]);

function isRoot(pathname: string): boolean {
  return ROOT_PATHS.has(pathname.replace(/\/+$/, '') || '/');
}

export function TelegramBackButton() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isTelegram() || isRoot(pathname)) return undefined;
    return showBackButton(() => navigate(-1));
  }, [pathname, navigate]);

  return null;
}

export default TelegramBackButton;
